/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiPaginatedResponseOfMcpChannelResponse } from '../model';
// @ts-ignore
import { SortDirection } from '../model';
/**
 * McpChannelsApi - axios parameter creator
 * @export
 */
export const McpChannelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {SortDirection} [sortDirection] 
         * @param {Array<string>} [allowedCountries] 
         * @param {object} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (limit?: number, page?: number, sortDirection?: SortDirection, allowedCountries?: Array<string>, sortBy?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/mcp/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (allowedCountries) {
                localVarQueryParameter['allowedCountries'] = allowedCountries;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * McpChannelsApi - functional programming interface
 * @export
 */
export const McpChannelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = McpChannelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {SortDirection} [sortDirection] 
         * @param {Array<string>} [allowedCountries] 
         * @param {object} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(limit?: number, page?: number, sortDirection?: SortDirection, allowedCountries?: Array<string>, sortBy?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaginatedResponseOfMcpChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(limit, page, sortDirection, allowedCountries, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * McpChannelsApi - factory interface
 * @export
 */
export const McpChannelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = McpChannelsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {SortDirection} [sortDirection] 
         * @param {Array<string>} [allowedCountries] 
         * @param {object} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(limit?: number, page?: number, sortDirection?: SortDirection, allowedCountries?: Array<string>, sortBy?: object, options?: any): AxiosPromise<ApiPaginatedResponseOfMcpChannelResponse> {
            return localVarFp.getPaginated(limit, page, sortDirection, allowedCountries, sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * McpChannelsApi - interface
 * @export
 * @interface McpChannelsApi
 */
export interface McpChannelsApiInterface {
    /**
     * 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {Array<string>} [allowedCountries] 
     * @param {object} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpChannelsApiInterface
     */
    getPaginated(limit?: number, page?: number, sortDirection?: SortDirection, allowedCountries?: Array<string>, sortBy?: object, options?: any): AxiosPromise<ApiPaginatedResponseOfMcpChannelResponse>;

}

/**
 * McpChannelsApi - object-oriented interface
 * @export
 * @class McpChannelsApi
 * @extends {BaseAPI}
 */
export class McpChannelsApi extends BaseAPI implements McpChannelsApiInterface {
    /**
     * 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {Array<string>} [allowedCountries] 
     * @param {object} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof McpChannelsApi
     */
    public getPaginated(limit?: number, page?: number, sortDirection?: SortDirection, allowedCountries?: Array<string>, sortBy?: object, options?: any) {
        return McpChannelsApiFp(this.configuration).getPaginated(limit, page, sortDirection, allowedCountries, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}
